import React from 'react';
import DateRangeSelector from './DateRangeSelector';

const CampaignPerformanceHeader = ({ 
    selectedCampaignId, 
    dateRangeType, 
    onDateRangeTypeChange, 
    dateFrom, 
    onDateFromChange, 
    dateTo, 
    onDateToChange 
}) => {
    return (
        <div style={{ marginBottom: '16px' }}>
            <h5>Campaign Performance Analysis</h5>
            <p style={{ fontSize: '12px', color: '#6c757d' }}>
                Campaign ID: {selectedCampaignId}
            </p>
            <DateRangeSelector
                dateRangeType={dateRangeType}
                onDateRangeTypeChange={onDateRangeTypeChange}
                dateFrom={dateFrom}
                onDateFromChange={onDateFromChange}
                dateTo={dateTo}
                onDateToChange={onDateToChange}
            />
        </div>
    );
};

export default CampaignPerformanceHeader;

